import $ from 'jquery';

$(function () {
    $("a, area").on("click",function (e) {
        var target = $(this).attr("href");
        if(target !== "" && target !== "#" && $(target).is(".modal-content")){
            e.preventDefault();
            $(target).show();
            $(target).closest(".modal").addClass("show");
        }
    });
    $(".modal, .modal .close-modal").on("click",function (e) {
        if($(e.target).is(".modal") || $(e.target).is(".close-modal")){
            e.preventDefault();
            $(".modal-content").attr("style","");
            $(".modal").removeClass("show");
        }
    });
})
